<template>
  <section class="mt-2" v-if="UpdateFolderRequestDTO && user.information">
    <b-overlay :show="loading" rounded="sm">
      
      <b-form-group label-cols-md="4" :label="$t('NAME')">
      <b-form-input trim :state="stateName"  v-on:keypress="isLettersAndNumbers($event)"
        :placeholder="$t('NAME')"
        v-model="UpdateFolderRequestDTO.name"
      ></b-form-input>
      </b-form-group>
        
      <div class="mt-2 error-text" v-if="UpdateFolderRequestDTO.name.length > 256">
        {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
      </div>

      <div class="mt-2 error-text" v-if="!isValidText">
        {{ $t("ERROR.CHARACTERS_NOT_ALLOWED") }} {{  notAllowedCharacters }}
      </div>
      
      <div class="text-right">
        <small class="pull-right">{{ UpdateFolderRequestDTO.name.length }}/256</small>
      </div>


      <hr class="p-0 m-0 mt-2 mb-2" />
      
      <b-button @click="cancelBtn" v-if="edited">{{ $t("CANCEL") }}</b-button>
      <b-button @click="closeBtn" v-if="!edited">{{ $t("CLOSE") }}</b-button>

      <b-button
        :disabled="updateDisabled"
        @click="updateBtn"
        variant="primary"
        class="btn-fill"
        >{{ $t("SAVE") }}</b-button
      >
      
    </b-overlay>
  </section>
</template>
<script>
export default {
  props: {
    information: {
      type: Object,
      default: null
    },
    user_uuid: {
      type: String,
      default: null,
    },
    clickRemove: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
  },
  data() {
    return {
      edited: false,
      loading: false,
      UpdateFolderRequestDTO: null,
    };
  },
  methods: {
    closeBtn() {
      this.$emit("close");
    },
    removeBtn: function () {
      let self = this;
      let RemoveFolderRequestDTO = {
        user_uuid: this.user_uuid,
        folder_uuid: this.information.folder_uuid
      };
      this.$bvModal
        .msgBoxConfirm(this.$t("ARE_YOU_SURE"), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          cancelTitle: this.$t("NO"),
        dialogClass: this.teams.theme,
          bodyClass: "messagebox",
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(function (value) {
          if (value) {
            self.loading = true;
            self.$http
              .post(
                self.user.hostname + "/filestorage/folder/remove",
                RemoveFolderRequestDTO
              )
              .then(() => {
                self.$emit("removedFolder");
              })
              .catch((error) => {
                self.loading = false;
                if(error.toString() == "Error: fail_4_4") return;
                self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
              });
          }
        })
        .catch(function () {});
    },
    cancelBtn() {
      this.name = "";
      this.$emit("cancelEdit");
    },
    updateBtn() {
      this.loading = true;
      let self = this;
      this.$http
        .post(
          this.user.hostname + "/filestorage/folder/update",
          this.UpdateFolderRequestDTO
        )
        .then(() => {
          self.loading = false;
          self.$emit("updatedInfo");
          self.name = "";
        })
        .catch((error) => {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t("ERROR.COULD_NOT_UPDATE"));
        });
    },
  },
  computed: {
    updateDisabled(){
      return this.information.name == this.UpdateFolderRequestDTO.name || this.UpdateFolderRequestDTO.name == "" || this.UpdateFolderRequestDTO.name.length > 256 || !this.validateLettersAndNumbers(this.UpdateFolderRequestDTO.name);
    },
    isValidText(){
      return this.UpdateFolderRequestDTO.name == "" || this.validateLettersAndNumbers(this.UpdateFolderRequestDTO.name);
    },
    stateName(){
      if(this.UpdateFolderRequestDTO.name == this.information.name)
      {
        return null;
      }
      return !this.updateDisabled;
    }
  },
  watch: {
    'UpdateFolderRequestDTO.name': function() {
      if(this.UpdateFolderRequestDTO.name != this.information.name)
      {
        this.edited = true;
        this.$emit('edited');
      }
    },
  },
  mounted() {
    if(this.clickRemove)
    {
      this.removeBtn();
    }
    this.UpdateFolderRequestDTO = {
      user_uuid: this.user_uuid,
      folder_uuid: this.information.folder_uuid,
      parent_uuid: this.information.parent_uuid,
      remove: 0,
      name: this.information.name,
    };
  },
};
</script>
<style>
</style>
